import { useEffect, useState } from 'react';
import { ROLE } from '../../../lib/constants';

/**
 * 報告書一覧画面における選択されている報告書IDの配列の状態管理を行うカスタムフック
 *
 * @param {Object[]} reports - 報告書の配列。
 * @param {string} currentUserRole - 現在のユーザーの権限。
 * @param {Object} currentUserInfo - 現在のユーザーの情報。
 * @param {number} currentPage - 現在の報告書一覧のページ番号
 * @returns {Object}
 * - selectedReportIds (number[]): 選択された報告書のIDの配列。
 * - toggleReportSelection (Function): 特定の報告書の選択状態をトグルする関数。
 * - toggleAllReportsSelection (Function): 表示されているすべての報告書を選択する関数。
 * - clearAllSelections (Function): すべての報告書の選択をクリアする関数。
 */
const useSelectedReportIdsState = (
  reports,
  currentUserRole,
  currentUserInfo,
  currentPage,
) => {
  const [selectedReportIds, setSelectedReportIds] = useState([]);

  const toggleReportSelection = reportId => {
    setSelectedReportIds(prevSelectedIds => {
      const updatedIds = prevSelectedIds.includes(reportId)
        ? prevSelectedIds.filter(id => id !== reportId)
        : [...prevSelectedIds, reportId];
      return updatedIds;
    });
  };

  const toggleAllReportsSelection = () => {
    const visibleReportIds = reports
      .filter(
        report =>
          currentUserRole === ROLE.COMPANY_ADMIN ||
          currentUserRole === ROLE.ADMIN ||
          (currentUserRole === ROLE.GENERAL &&
            currentUserInfo.operatorId === report.createdOperatorId),
      )
      .map(report => report.id);

    const areAllSelected = visibleReportIds.every(id =>
      selectedReportIds.includes(id),
    );

    setSelectedReportIds(areAllSelected ? [] : visibleReportIds);
  };

  const clearAllSelections = () => {
    setSelectedReportIds([]);
  };

  useEffect(() => {
    clearAllSelections();
  }, [currentPage]);

  return {
    selectedReportIds,
    toggleReportSelection,
    toggleAllReportsSelection,
    clearAllSelections,
  };
};

export default useSelectedReportIdsState;
